import { render } from "./VideoNavigationComponent.vue?vue&type=template&id=1770814f"
import script from "./VideoNavigationComponent.vue?vue&type=script&lang=js"
export * from "./VideoNavigationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__